<template>
  <v-layout row wrap align-center justify-center>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <h1>{{ meta.title }}</h1>
          <v-spacer></v-spacer>
          <v-btn
            small
            v-if="canBooking('BOOK_TRIAL')"
            color="warning"
            :to="{ name: allRoutes.booking.children.bookAtrial.name }">
            Quick book
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <data-table
            :model="model"
            :search="search"
            :headers="headers"
            :selected.sync="selected"
            @edit="editItem"
            @delete="deleteItem"
            @detail="showItem"
            @deleteSelected="deleteSelectedItem"
          />
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Booking from '@/orm/models/Booking';
import ProcessStages from '@/orm/models/ProcessStages';
import { CONST } from '@/utils';
import asyncComponent from '@/utils/asyncComponent';

export default {
  name: 'bookingAll',
  async asyncData() {
    await ProcessStages.$fetch();
  },
  data() {
    return {
      model: Booking,
      search: '',
      headers: CONST.booking.headers,
      selected: [],
    };
  },
  computed: {
    meta() {
      return this.$route.meta;
    },
  },
  methods: {
    editItem(id) {
      this.$router.push({
        name: this.allRoutes.booking.children.bookingDetail.name,
        params: { id, editMode: true },
      });
    },
    async deleteItem(id) {
      await Booking.delete(+id);
      await Booking.$delete({
        params: { id },
      });
    },
    async deleteSelectedItem() {
      for (let { id } of this.selected) {
        await this.deleteItem(id);
      }
    },
    showItem(id) {
      this.$router.push({
        name: this.allRoutes.booking.children.bookingDetail.name,
        params: { id },
      });
    },
  },
  components: {
    dataTable: asyncComponent({
      component: 'components/data/dataTable',
    }),
  },
};
</script>
